import styled from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';
import { AllieItem } from '../../../components/Item/Item';
import { AllieList } from '../../../components/List';
import { AllieTextArea } from '../../../components';

export const ModalShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
  overflow: hidden;
`;

export const ModalHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 24px;
  border-bottom: 1px solid var(--allie-color-neutral-20);
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const ModalHeaderCloseButton = styled(AllieButton)`
  --background: transparent;
  --color: var(--allie-color-neutral-60);
  color: var(--allie-color-neutral-60);
  --padding-top: 4px;
  --padding-bottom: 4px;
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0;
  min-height: auto;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  transition: background-color 0.15s;

  > span {
    display: contents;
  }

  ion-icon {
    width: 13px;
    height: 13px;
  }

  &:hover {
    --border-radius: 8px;
    color: var(--allie-color-neutral-60);
    --background: var(--allie-color-neutral-10);
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.25rem 1.75rem;
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-color: var(--allie-color-neutral-40) var(--allie-color-neutral-10);
`;

export const WizardWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const AlllieListStyled = styled(AllieList)`
  display: grid;
  row-gap: 1.25rem;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 0;
  margin-top: 16px;

  &.step-1 {
    --padding-start: 0;
    --inner-padding-end: 0;
  }


  ion-item.with-border {
    border: 1px solid var(--allie-color-neutral-20);
    border-radius: 8px;
    --padding-start: 16px;
    --inner-padding-end: 16px;
  }

  ion-item.item-radio-checked {
    border-width: 3px;
  }

  ion-item.item-select {
    --background-hover: none;
  }

  ion-radio-group {
    display: grid;
    row-gap: 12px;
  }

  ion-radio {
    --color-checked: var(--allie-color-primary-50);
  }

  ion-radio.ios {
    width: 24px;
    height: 24px;

    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .radio-checked.ios {
    border-color: var(--allie-color-primary-50);
  }
`;

export const ItemForm = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: 100%;

  ion-text {
    letter-spacing: -0.015em;
  }

  ion-select {
    max-width: none;
  }

  & ion-input {
    width: 100%;
  }
`;

export const QuickStopReasonAssignButtons = styled(AllieItem)<{ isSelected?: boolean }>`
  --background: none;
  border: 1px solid
    ${({ isSelected }) =>
      isSelected ? 'var(--allie-color-primary-60)' : 'var(--allie-color-neutral-30)'};
  border-radius: var(--allie-radius-lg);
  background: ${({ isSelected }) => (isSelected ? 'var(--allie-color-primary-60)' : 'none')};
  ion-icon {
    color: ${({ isSelected }) => (isSelected ? 'white' : 'black')};
  }

  span {
    width: 100%;
  }
`;

export const StopTypeAssignButton = styled(AllieButton)<{ isSelected?: boolean }>`
  --border-color: ${({ isSelected }) =>
    isSelected ? 'var(--allie-color-primary-60)' : 'var(--allie-color-neutral-30)'};
  --border-radius: var(--allie-radius-3xl);
  --padding-top: var(--allie-spacing-md);
  --padding-bottom: var(--allie-spacing-md);
  --padding-start: var(--allie-spacing-xl);
  --padding-end: var(--allie-spacing-xl);
  letter-spacing: normal;
  margin: 0;

  ion-icon {
    color: ${({ isSelected }) => (isSelected ? 'white' : 'black')};
  }

  span {
    width: 100%;
  }
`;

export const StyledConfirmReasonBox = styled.div`
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: var(--allie-radius-lg);
  padding: 12px;
  box-sizing: border-box;
`;

export const StyledLastAssignedReasonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 12px;
`;

export const StyledSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 392px;

  ion-spinner {
    width: 60px;
    height: 60px;
  }
`;

export const StyledStopTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StopTypeButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const QuickButtonContainer = styled.div`
  display: grid;
  row-gap: var(--allie-spacing-lg);
  width: 100%;
  overflow-y: auto;
  flex-shrink: 0;
`;

export const StyledEmptyStateCTA = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--allie-color-primary-60);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--allie-color-primary-50);
  }
`;

export const StopTypeFilterLabel = styled.div`
  font-size: 0.875rem;
  color: var(--allie-color-neutral-50);
`;

export const ConfirmSummaryCard = styled.div`
  border: 1px solid var(--allie-color-neutral-20);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
`;

export const ConfirmSummaryRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ConfirmSummaryLabel = styled.span`
  font-size: 0.75rem;
  color: var(--allie-color-neutral-50);
  font-weight: 400;
`;

export const ConfirmSummaryValue = styled.span`
  font-size: 0.875rem;
  color: var(--allie-color-primary-90);
  font-weight: 400;
`;

export const ConfirmSummaryValueMuted = styled.span`
  font-size: 0.875rem;
  color: var(--allie-color-neutral-40);
  font-weight: 400;
`;

export const RequiredAsterisk = styled.span`
  color: var(--allie-color-error-main);
  margin-left: 2px;
`;

export const TextAreaNoMargin = styled(AllieTextArea)`
  && {
    margin-top: 0;
  }
`;
